import { Config, makeFetcher } from '@/utils/fetch';
import { config } from '@/config';
import {
    IContactSupport,
    IUnsubscribeAll,
    IContactPreferences,
    IGetContactPreferences,
} from '@/types/types/forms/contactPreferences/contactPreferences.interface';

const makeContactPreferencesService = (apiUrl: string) => {
    const fetcher = makeFetcher(apiUrl);

    return {
        contactSupport: async (data: Partial<IContactSupport>, userIdCode?: string) => {
            const body = JSON.stringify({ ...data, userIdCode });
            const res = await fetcher.post('/contact-support', body);
            return res.status;
        },

        getCurrentContactPreferences: async (userIdCode?: string, config?: Config) => {
            const queryParam = userIdCode ? `?userIdCode=${userIdCode}` : '';
            const res = await fetcher.get(`${queryParam}`, config);
            const data = (await res.json()) as IGetContactPreferences;
            return data;
        },

        updateContactPreferences: async (
            data: Partial<IContactPreferences>,
            userIdCode?: string,
            source?: string,
        ) => {
            const body = JSON.stringify({ ...data, userIdCode, source });
            const res = await fetcher.patch('', body);
            return res.status;
        },

        getReasons: async (userIdCode?: string, config?: Config) => {
            const queryParam = userIdCode ? `?userIdCode=${userIdCode}` : '';
            const res = await fetcher.get(`/unsubscribe/reasons${queryParam}`, config);
            return (await res.json()) as number[];
        },

        unsubscribeAll: async (data: Partial<IUnsubscribeAll>, userIdCode?: string) => {
            const body = JSON.stringify({ ...data, userIdCode });
            const res = await fetcher.post('/unsubscribe/all', body);
            return res.status;
        },
    };
};

export const contactPreferencesService = makeContactPreferencesService(
    config.api.url.contactPreferences,
);
